import { render, staticRenderFns } from "./PersonDialogExistingPeople.vue?vue&type=template&id=8cfacab0"
import script from "./PersonDialogExistingPeople.vue?vue&type=script&lang=js"
export * from "./PersonDialogExistingPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports